import React from "react";
import styled from "styled-components";
import { useBackdropContext } from "../context";
const _Background = ({ children, ...componentProps }) => {
    useBackdropContext("BackdropBackground");
    return React.createElement("div", { ...componentProps }, children);
};
_Background.defaultProps = {
    "data-testid": "backdrop-background",
};
export const BackdropBackground = styled(_Background) ``;
//# sourceMappingURL=Background.js.map